import React from 'react';

function AlarmComponent() {
    return <div>AlarmComponent</div>;
}

export default AlarmComponent;
